import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-5 md:max-w-[624px] px-5 md:px-10 py-5 bg-white border border-neutral-500 rounded-lg" }
const _hoisted_2 = { class: "flex flex-col gap-3" }
const _hoisted_3 = { class: "text-lg font-semibold" }
const _hoisted_4 = { class: "text-gray-600 text-sm" }
const _hoisted_5 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_6 = { class: "flex flex-col gap-3" }
const _hoisted_7 = { class: "text-lg font-semibold" }
const _hoisted_8 = { class: "text-gray-600 text-sm" }
const _hoisted_9 = {
  key: 0,
  class: "mt-2"
}

import Button from '../base/Button.vue';
import { inject, ref } from 'vue';
import { AppConfigType } from '~src/admin/types';
import Axios from '~src/shared/axios';
import { useGettext } from 'vue3-gettext';

// Translations

export default /*@__PURE__*/_defineComponent({
  __name: 'ApiConnection',
  setup(__props) {

const { $gettext } = useGettext();

// Get plugin config
const config: AppConfigType = inject('pluginConfig');

// Loading states
const checkConnectionLoading = ref(false);
const resetTokenLoading = ref(false);

// Message states
const connectionMessage = ref('');
const connectionMessageType = ref<'success' | 'error'>('success');
const tokenMessage = ref('');
const tokenMessageType = ref<'success' | 'error'>('success');

// Account expired
const isAccountExpired = inject<boolean>('isAccountExpired');

const checkApiConnection = async () => {
    try {
        // Reset message
        connectionMessage.value = '';

        // Set loading
        checkConnectionLoading.value = true;

        // Call the REST API to check connection
        const response = await Axios.post(`${config.rest.endpoints.settings}/check_connection`);

        // Check if the response is successful
        if (response.status !== 200 && !response.data.success) {
            throw new Error(`REST API error: ${response.status} - ${response.statusText}`);
        }

        // Show success message
        connectionMessage.value = $gettext('API connection is working correctly!');
        connectionMessageType.value = 'success';
    } catch (error) {
        // Show error
        console.error('Error checking API connection:', error);

        connectionMessage.value = $gettext('API connection failed. You may need to reset your API token.');
        connectionMessageType.value = 'error';
    } finally {
        // Set loading
        checkConnectionLoading.value = false;
    }
};

const resetApiToken = async () => {
    try {
        // Reset message
        tokenMessage.value = '';

        // Set loading
        resetTokenLoading.value = true;

        // Call the REST API to reset token
        const response = await Axios.post(`${config.rest.endpoints.settings}/request_api_key_reset`);

        // Check if the response is successful
        if (response.status !== 200 && !response.data.success) {
            throw new Error(`REST API error: ${response.status} - ${response.statusText}`);
        }

        // Show success message
        tokenMessage.value = $gettext('Email has been sent to you! Please check your inbox.');
        tokenMessageType.value = 'success';
    } catch (error) {
        // Show error
        console.error('Error resetting API token:', error);

        tokenMessage.value = $gettext('There was an error while sending the email!');
        tokenMessageType.value = 'error';
    } finally {
        // Set loading
        resetTokenLoading.value = false;
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref($gettext)('API Connection')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref($gettext)('Test your API connection to ensure everything is working properly.')), 1),
      _createVNode(Button, {
        class: "max-md:w-full self-start",
        type: "primary",
        text: _unref($gettext)('Check API Connection'),
        size: "large",
        disabled: _unref(isAccountExpired),
        loading: checkConnectionLoading.value,
        onClick: _withModifiers(checkApiConnection, ["prevent"])
      }, null, 8, ["text", "disabled", "loading"]),
      (connectionMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", {
              class: _normalizeClass([
                        'text-sm font-medium',
                        connectionMessageType.value === 'success' ? 'text-green-600' : 'text-red-600',
                    ])
            }, _toDisplayString(connectionMessage.value), 3)
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "border-neutral-300" }, null, -1)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref($gettext)('API Token')), 1),
      _createElementVNode("p", _hoisted_8, _toDisplayString(_unref($gettext)(
                        'Reset your API token if you have problems with the connection. You will receive a link to reset the key in your email.'
                    )), 1),
      _createVNode(Button, {
        class: "max-md:w-full self-start",
        type: "danger",
        text: _unref($gettext)('Reset API Token'),
        size: "large",
        disabled: _unref(isAccountExpired),
        loading: resetTokenLoading.value,
        onClick: _withModifiers(resetApiToken, ["prevent"])
      }, null, 8, ["text", "disabled", "loading"]),
      (tokenMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("p", {
              class: _normalizeClass(['text-sm font-medium', tokenMessageType.value === 'success' ? 'text-green-600' : 'text-red-600'])
            }, _toDisplayString(tokenMessage.value), 3)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})